/**
 * This function takes a string and returns the the same string as a camelCase string
 * @param {string} string - The string that should be converted to camelCase
 * @returns {string} - The inputted string as camelCase
 */
export default function camelCase(string) {
    return string
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '');
}
